<template>
  <div>
    <!-- Loading -->
    <div class="flex-all-center" v-if="isLoadingRanking">
      <img src="../../../assets/images/loading.gif" alt="loading" />
    </div>
    <!-- 検索結果が0件 -->
    <div class="flex-all-center" v-if="isNotFound">
      {{ Ranking.notFound[lang] }}
    </div>
    <!-- サーバーエラー -->
    <div class="text-center" v-if="isServerError">
      <div>
        {{ Ranking.failure[lang] }}
      </div>
      <div class="update-area">
        <button type="button" @click="emitRanking" class="button">
          {{ Ranking.update[lang] }}
        </button>
      </div>
    </div>
    <!-- 更新時間 -->
    <div
      class="update-time"
      v-if="
        !isLoadingRanking && !isNotFound && !isServerError && eventDateAt[lang]
      "
    >
      {{ eventDateAt[lang] }}
    </div>
    <!-- 見つかった件数 -->
    <div
      class="hit"
      v-if="
        !isLoadingRanking &&
        !isNotFound &&
        !isServerError &&
        isInitialRankingData
      "
    >
      {{ countTotalRunner }}{{ Ranking.hit[lang] }}
    </div>
    <!-- 完走証文言 -->
    <div
      v-if="!isLoadingRanking && !isNotFound && eventStatus === '0'"
      class="certificate-download flex-all-center"
    >
      {{ Ranking.certificateDescription[lang] }}
    </div>
  </div>
</template>

<script>
import Ranking from "../../../assets/constants/ranking/ranking.json";
export default {
  methods: {
    emitRanking: function () {
      this.$emit("initial-ranking");
    },
  },
  props: {
    isLoadingRanking: Boolean,
    isNotFound: Boolean,
    isServerError: Boolean,
    isInitialRankingData: Boolean,
    countTotalRunner: Number,
    eventStatus: String,
    eventDateAt: String,
  },
  computed: {
    Ranking: function () {
      return Ranking;
    },
    lang: function () {
      return this.$store.state.lang;
    },
  },
  name: "Status",
};
</script>

<style scoped>
.update-time {
  font-size: 14px;
  text-align: right;
}
.hit {
  margin: 10px 0 0 0;
  color: #70757a;
}
.certificate-download {
  margin: 10px 0 0 0;
  padding: 10px;
  font-size: 12px;
  background-color: var(--defaultGrayColor);
}
.update-area {
  margin: 12px 0 0 0;
  .button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 140px;
    height: 45px;
    border: solid 1px var(--defaultBlackColor);
    background-color: var(--defaultWhiteColor);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/ranking/Status.vue